export default __webpack_public_path__ + "static/media/town.a9afcf0f.svg";